import { SvgSymbol } from '@domgen/base-design-system-2.0/atoms/SvgSymbol/SvgSymbol';

export type ProtectionItem = {
  heading: string;
  text: string;
  icon: React.ReactNode;
};

export interface HowApplianceCareWorksContent {
  title: string;
  protection: ProtectionItem[];
}

export const howApplianceCareWorksContent = (
  brandName: string,
  spritePath: string,
): HowApplianceCareWorksContent => {
  return {
    title: `How does ${brandName} Appliance Care work?`,
    protection: [
      {
        heading: 'Appliance broken?',
        text: 'Make a claim via My Account or give us a call — no deductibles.',
        icon: (
          <SvgSymbol
            symbol="WashingMachineLeaking"
            className="w-100 h-100 shrink-0"
            width={100}
            height={100}
            spritePath={spritePath}
          />
        ),
      },
      {
        heading: 'On the day of technician visit...',
        text: `We'll do our best to repair it.`,
        icon: (
          <SvgSymbol
            symbol="EngineerVan"
            className="w-100 h-100 shrink-0"
            width={100}
            height={100}
            spritePath={spritePath}
          />
        ),
      },
      {
        heading: "If we can't fix it...",
        text: `We'll offer like-for-like appliance.`,
        icon: (
          <SvgSymbol
            symbol="PersonDollyWashingMachine"
            className="w-100 h-100 shrink-0"
            width={100}
            height={100}
            spritePath={spritePath}
          />
        ),
      },
    ],
  };
};
